class Content {
  constructor() {
    // CMS NavigationHelper handles external links, otherwise they're manually applied

    this.mailToLinks = document.querySelectorAll('a[href^=mailto]');

    if (this.mailToLinks && this.mailToLinks.length > 0) {
      this.mailtoWordBreak(this.mailToLinks);
    }
  }

  /**
   * Inserts a word break element after the @ symbol in a mailto link
   * @param {nodeList} elementList
   */
  mailtoWordBreak(elementList) {
    for (let element of elementList) {
      // some links are inside collapsed areas where grabbing innerText returns empty
      // and don't want to override any inner spans required for other component formatting
      const spanLayer = element.querySelector('span');
      const rawText = spanLayer?.textContent?.trim() ?? element.textContent.trim();

      const formatted = rawText.replace(/([@.])/g, '<wbr>$1');
      if (!formatted) {
        continue;
      }

      if (spanLayer) {
        spanLayer.innerHTML = formatted;
      } else {
        element.innerHTML = formatted;
      }
    }
  }
}

export default Content;
